import React, { useEffect, useState } from 'react';
import {
    Box,
    Typography,
    Button,
    Card,
    Divider,
    CircularProgress,
    Grid,
    CardContent
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { t } from 'i18next';
import { fetchLearningByUUID } from '../../../services/aprender';
import BulkAssignDialog from './BulkAssignDialog';

const AprenderVer = () => {
    const { uuid } = useParams();
    const theme = useTheme();
    const navigate = useNavigate();
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [openAssignDialog, setOpenAssignDialog] = useState(false);

    useEffect(() => {
        const loadContent = async () => {
            setLoading(true);
            try {
                const data = await fetchLearningByUUID(uuid);
                setContent(data);
            } catch {
                setError('Não foi possível carregar o conteúdo.');
            } finally {
                setLoading(false);
            }
        };
        loadContent();
    }, [uuid]);

    if (loading)
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="80vh">
                <CircularProgress />
            </Box>
        );

    if (error)
        return (
            <Box textAlign="center" mt={5}>
                <Typography color="error">{error}</Typography>
                <Button
                    variant="outlined"
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate('/aprender')}
                    sx={{ mt: 2 }}
                >
                    {t('learning.back')}
                </Button>
            </Box>
        );

    return (
        <Card sx={{ m: 2 }}>
            <CardContent>
                <Box display="flex" gap={2}>
                    <Button variant="contained" onClick={() => setOpenAssignDialog(true)}>
                        {t('learning.assign')}
                    </Button>
                </Box>
                <BulkAssignDialog
                    open={openAssignDialog}
                    onClose={() => setOpenAssignDialog(false)}
                    contentUUIDs={uuid}
                />
                <Divider sx={{ mt: 2 }} />

                <Box sx={{ m: 3 }}>
                    <Card>
                        <Grid item xs={12}>
                            <Typography
                                variant="h1"
                                align="center"
                                gutterBottom
                                sx={{ color: theme.palette.primary.dark }}
                            >
                                {content.title}
                            </Typography>
                            <Typography
                                variant="body1"
                                align="center"
                                gutterBottom
                                sx={{ fontSize: '18px' }}
                            >
                                {content.description}
                            </Typography>
                            <Typography
                                variant="body1"
                                align="center"
                                gutterBottom
                                sx={{ fontSize: '14px' }}
                            >
                                {t('learning.created_on')}{' '}
                                {new Date(content.created).toLocaleDateString()}
                            </Typography>
                        </Grid>
                    </Card>
                </Box>

                <Divider sx={{ mt: 2, mb: 3 }} />

                {/*CONTEÚDO HTML */}
                <Card
                    sx={{
                        maxWidth: 900,
                        mx: 'auto',
                        p: 4,
                        borderRadius: 4,
                        boxShadow: 3,
                        backgroundColor: '#fff'
                    }}
                >
                    <Box
                        className="ql-editor"
                        sx={{
                            '& h1, h2, h3': { color: '#1976d2' },
                            '& p': { lineHeight: 1.7, color: '#333' },
                            '& img': {
                                display: 'block',
                                margin: '24px auto',
                                maxWidth: '90%',
                                height: 'auto'
                            },
                            '& video, & audio': {
                                display: 'block',
                                margin: '20px auto',
                                maxWidth: '100%'
                            },
                            '& iframe': {
                                display: 'block',
                                margin: '20px auto',
                                maxWidth: '100%'
                            }
                        }}
                        dangerouslySetInnerHTML={{ __html: content.content }}
                    />
                </Card>
            </CardContent>
        </Card>
    );
};

export default AprenderVer;
